import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

const PreAssessmentQuestionDruidChatbot = ({ setPreAssessmentData }) => {
  // Observer to watch for new chatbot messages
  useEffect(() => {
    let observer;

    const excludeKeywords = [
      "Start Now",
      "Next Set Question",
      "Write Custom Question",
      "Self-Assessment Questions Completed",
    ];

    const isValidQuestion = (text) => {
      return !excludeKeywords.some((keyword) => text.includes(keyword));
    };

    const observeChatbot = () => {
      const parentNode = document.querySelector(
        ".webchat__basic-transcript__transcript"
      );
      if (!parentNode) {
        setTimeout(observeChatbot, 500);
        return;
      }

      observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              if (node.textContent.includes("You said:")) {
                const matches = node.textContent.match(
                  /(?<=You said: )(.+?)(?= You said:|$)/gi
                );

                if (matches && isValidQuestion(matches[0])) {
                  setPreAssessmentData((prev) => ({
                    ...prev,
                    questions: [
                      ...prev.questions,
                      {
                        id: uuidv4(),
                        question: matches[0],
                      },
                    ],
                  }));
                }
              }
            });
          }
        });
      });

      observer.observe(parentNode, { childList: true, subtree: true });
    };

    observeChatbot();

    return () => {
      if (observer) observer.disconnect();
    };
  }, []);

  useEffect(() => {
    const loadJSScript = (src, callback) => {
      const existingScript = document.getElementById("druid_webchat_v2_js");
      if (!existingScript) {
        const script = document.createElement("script");
        script.src = src;
        script.id = "druid_webchat_v2_js";
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => {
          if (callback) callback();
        };
      } else if (callback) callback();
    };

    const loadCSS = (src, callback) => {
      const existingCSS = document.getElementById("druid_webchat_v2_css");
      if (!existingCSS) {
        const druidStyles = document.createElement("link");
        druidStyles.href = src;
        druidStyles.rel = "stylesheet";
        druidStyles.id = "druid_webchat_v2_css";
        document.head.appendChild(druidStyles);

        druidStyles.onload = () => {
          if (callback) callback();
        };
      } else if (callback) callback();
    };

    const initializeChatbot = () => {
      const currentUrl = new URL(
        "https://Abhijeet.community.druidplatform.com/v2/druid_webchat_v2_load.js?botId=c566b5e6-0ed1-4fcb-ad9b-08dcf4e23764&baseUrl=https%3A%2F%2Fdruidapi.comm.eu.druidplatform.com"
      );
      const widgetBaseUrl = currentUrl.href.substring(
        0,
        currentUrl.href.lastIndexOf("/") + 1
      );

      loadJSScript(`${widgetBaseUrl}druid_webchat_v2.js`, () => {
        loadCSS(`${widgetBaseUrl}druid_webchat_v2.css`, () => {
          const initialOptions = {};
          for (const key of currentUrl.searchParams.keys()) {
            initialOptions[key] = currentUrl.searchParams.get(key);
          }
          initialOptions["druidWebChatIsOpenedEnabled"] = false;
          if (window.DruidWebchat_v2) {
            window.DruidWebchat_v2.init(initialOptions);
          }
        });
      });
    };

    // Initialize the chatbot when the component mounts
    initializeChatbot();

    // Cleanup on unmount
    return () => {
      // Destroy the chatbot
      if (window.DruidWebchat_v2) {
        window.DruidWebchat_v2.destroy(window.DruidWebchat_v2);
      }
      // Remove the script
      const script = document.getElementById("druid_webchat_v2_js");
      if (script) document.body.removeChild(script);

      // Remove the CSS
      const css = document.getElementById("druid_webchat_v2_css");
      if (css) document.head.removeChild(css);

      // Remove chatbot DOM elements (audio, divs, etc.)
      const elementsToRemove = [
        "druid-new-message-notification",
        "druidWebchatRoot_v2",
        "druid__default_container-element",
      ];
      elementsToRemove.forEach((id) => {
        const element = document.getElementById(id);
        if (element) element.parentNode.removeChild(element);
      });

      // Remove elements with specific class names
      const classesToRemove = [
        "druidWebchatRoot_v2",
        "druid__web-chat__root-container",
        "druid__minimizable__web-chat",
      ];
      classesToRemove.forEach((className) => {
        const elements = document.getElementsByClassName(className);
        Array.from(elements).forEach((el) => el.parentNode.removeChild(el));
      });

      // Clean up any lingering global variables
      if (window.DruidWebchat_v2) {
        delete window.DruidWebchat_v2;
      }
    };
  }, []);

  return null; // No additional DOM elements required
};

export default PreAssessmentQuestionDruidChatbot;
